export default "\r\n  <p-growl [value]=\"msgs\" life=\"3000\"></p-growl>\r\n  <p>\r\n    myprofile works!\r\n  </p>\r\n\r\n"